<template>
  <div class="prmisePage" v-loading="loading">
    <backgroundTop title="遵义医科大学附属医院" />
    <div class="container">
      <el-card>
        <div class="notice">
          <p class="title">报名须知</p>
          <el-divider></el-divider>
          <p :key="index" v-for="(item, index) in paromise">
            {{ item }}
          </p>
        </div>
        <div class="btnDiv">
          <el-button type="primary" @click="onAgree">同意</el-button>
          <el-button type="danger" class="disAgreeBtn" @click="onDisAgree">不同意</el-button>
        </div>
      </el-card>
    </div>
    <CopyRight></CopyRight>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import backgroundTop from '../components/backgroundTop'
import CopyRight from '../components/CopyRight'
export default {
  components: {
    backgroundTop,
    CopyRight
  },
  data() {
    return {
      loading: false,
      notice: '',
      paromise: []
    }
  },
  created() {
    let reg = window.sessionStorage.getItem('registration')
    // if (!reg) {
    //   this.$router.go(-1)
    //   alert('ok')
    // }
    this.noticeApi()
  },
  // computed: {
  //   ...mapState({ registration: 'registration' })
  // },
  methods: {
    ...mapMutations({
      setRegistration: 'SET_REGISTRATION'
    }),
    // Api
    async noticeApi() {
      let registration = JSON.parse(window.sessionStorage.getItem('registration'))
      console.log(registration)
      const { data: res } = await this.$axios.get('/api/signup/signupNotice', { params: { signupId: registration.signup_id } })
      console.log(res)
      if (res.response_code == 200) {
        this.notice = res.data
        this.paromise = this.notice.signup_info.split(/[\n,]/g)
      }
    },
    onAgree() {
      // this.setPromise(true)

      let info = JSON.parse(window.sessionStorage.getItem('registration'))
      info.agree = true
      let registration = JSON.stringify(info)
      this.setRegistration(registration)
      this.$router.push('/ApplyActive')
    },
    onDisAgree() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/style/mixin.scss';

.el-card {
  margin-top: 25px;
  @include autoInner;
}

.prmisePage {
  .container {
    min-height: calc(100vh - 330px);
  }
  .title {
    text-align: center;
    font-size: 24px;
    font-weight: 700;
  }

  .notice {
    padding: 24px;

    p {
      padding: 10px 0;
    }
  }

  .btnDiv {
    float: right;
    padding: 30px;

    .el-button {
      width: 100px;
    }

    .disAgreeBtn {
      margin-left: 30px;
    }
  }
}
</style>
